import { useAuiState } from "@assistant-ui/react";
import { useMemo } from "react";
import { useAgentActivity } from "./AgentActivityContext";
import { AGENT_ACTIVITY_KEY, NO_ACTIVITY, type AgentActivity } from "./agentActivity";

function parseSteps(raw: unknown): readonly AgentActivity[] {
  if (!Array.isArray(raw)) return NO_ACTIVITY;
  const steps: AgentActivity[] = [];
  for (const item of raw) {
    if (!item || typeof item !== "object") continue;
    const { id, title, detail, status } = item as Record<string, unknown>;
    if (typeof id !== "string" || !id || typeof title !== "string" || !title) continue;
    if (status !== "running" && status !== "done") continue;
    steps.push({ id, title, detail: typeof detail === "string" ? detail : "", status });
  }
  return steps.length > 0 ? steps : NO_ACTIVITY;
}

export function useActivitySteps(): readonly AgentActivity[] {
  const contextActivities = useAgentActivity();
  const raw = useAuiState((state) => state.message.metadata?.custom?.[AGENT_ACTIVITY_KEY]);
  const isRunning = useAuiState((state) => state.message.status?.type === "running");

  return useMemo(() => {
    const stored = parseSteps(raw);
    const source = stored.length > 0 ? stored : isRunning ? contextActivities : NO_ACTIVITY;
    return isRunning
      ? source
      : source.map((step) =>
          step.status === "running" ? { ...step, status: "done" as const } : step,
        );
  }, [raw, isRunning, contextActivities]);
}
